import React from 'react';
import { InconsistentFieldTag } from './InconsistentFieldTag';

import styles from './FieldWithTag.module.scss';

export const FieldWithTag = ({ children, showTag, fieldName, barcode, className = '' }) => {
	return (
		<div className={`${styles.fieldContainer} ${className}`}>
			<div className={styles.fieldContent}>{children}</div>
			{showTag && (
				<div className={styles.tagContainer}>
					<InconsistentFieldTag fieldName={fieldName} barcode={barcode} />
				</div>
			)}
		</div>
	);
};
